 
export const AuthProviderModel = {
    authProviderName: "",
    authProviderDetails: [
        {
            detailName: "",
            detailValue: "",
        }
    ],
    authProviderID: "",
 };
